var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4583 8.125H13.5417C10.5501 8.125 8.125 10.5501 8.125 13.5417V51.4583C8.125 54.4499 10.5501 56.875 13.5417 56.875H51.4583C54.4499 56.875 56.875 54.4499 56.875 51.4583V13.5417C56.875 10.5501 54.4499 8.125 51.4583 8.125Z",
    stroke: "#505050",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0208 27.0833C25.2645 27.0833 27.0833 25.2644 27.0833 23.0208C27.0833 20.7771 25.2645 18.9583 23.0208 18.9583C20.7772 18.9583 18.9583 20.7771 18.9583 23.0208C18.9583 25.2644 20.7772 27.0833 23.0208 27.0833Z",
    stroke: "#505050",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 40.6249L43.3333 27.0833L13.5417 56.8749",
    stroke: "#505050",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.1b56db9728a6c731f6a0159e2e18cde2.svg";
export { ForwardRef as ReactComponent };